<template>
  <v-card
    tile
    elevation="1"
  >
    <v-list-item
      v-for="translation in translations"
      :key="`translation-${translation.id}`"
      @click="edit(translation)"
    >
      <template #default>
        <v-list-item-icon>
          <v-icon
            :color="isMissingTranslations(translation) ? 'orange' : 'green'"
            v-text="isMissingTranslations(translation) ? 'mdi-alert-circle' : 'mdi-check-circle'"
          />
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ allLanguages[translation.language_code].name }}
          </v-list-item-title>
        </v-list-item-content>

        <!-- <v-list-item-action>
          <v-btn
            icon
            color="primary"
            @click.stop.prevent="remove(translation)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action> -->
      </template>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  props: {
    faqId: {
      type: Number,
      required: true
    },
    questionId: {
      type: Number,
      required: true
    },
    translations: {
      type: Array,
      required: true
    },
    allLanguages: {
      type: Object,
      required: true
    },
    missingTranslations: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      deleteForm: this.$inertia.form({ }),
    }
  },

  methods: {
    edit(translation) {
      const url = this.route('faq.question-translation.edit', {
        faq: this.faqId,
        question: this.questionId,
        questionTranslation: translation.id
      });

      this.$inertia.get(url, {}, {
        preserveState: true,
        preserveScroll: true
      });
    },

    async remove(translation) {
      const confirmed = await this.$root.$confirm(
        `Remove question translation`,
        `Are you sure you want to remove the '${translation.language.name}' translation?`
      );

      if (! confirmed) {
        return;
      }

      const url = this.route('faq.question-translation.destroy', {
        faq: this.faqId,
        question: this.questionId,
        questionTranslation: translation.id
      });

      this.deleteForm.delete(url);
    },

    isMissingTranslations(model) {
      return this.missingTranslations.questions[this.questionId][model.language_code];
    },
  },
}
</script>